export default "__VITE_ASSET__D9usCI87__"